/* eslint-disable react/prop-types */
import React from 'react';

const TONE = {
  SUPERFICIAL:       { bg: 'bg-stone-100',   text: 'text-stone-700',   border: 'border-stone-300' },
  EXPLORATORY:       { bg: 'bg-sky-50',      text: 'text-sky-700',     border: 'border-sky-200' },
  REFLECTIVE:        { bg: 'bg-violet-50',   text: 'text-violet-700',  border: 'border-violet-200' },
  REALIZATION_LEVEL: { bg: 'bg-amber-50',    text: 'text-amber-800',   border: 'border-amber-300' },
  DECISION_LEVEL:    { bg: 'bg-emerald-50',  text: 'text-emerald-800', border: 'border-emerald-300' },
  FAMILY_ALIGNMENT:  { bg: 'bg-rose-50',     text: 'text-rose-800',    border: 'border-rose-300' },
  CONVERSION_LEVEL:  { bg: 'bg-emerald-700', text: 'text-white',       border: 'border-emerald-800' },
};

export default function ConversationDepthBadge({ tier, code, label, compact = false }) {
  if (!code) return null;
  const tone = TONE[code] || TONE.SUPERFICIAL;
  return (
    <span
      data-testid={`depth-badge-${code}`}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] uppercase tracking-[0.14em] font-['Work_Sans'] ${tone.bg} ${tone.text} ${tone.border}`}
    >
      <span className="tabular-nums opacity-70">T{tier ?? ''}</span>
      {!compact && (label || code.replace(/_/g, ' ').toLowerCase())}
    </span>
  );
}
